<template>
    <!-- overflow: hidden -->
    <div class="cairline-left">
        <div class="left-title">{{ $t('taskPage.left.taskList') }}</div>
        <div class="left-content">
            <div class="add-btn" v-if="userObj['fcs:task:add']" @click="addNewTask">
                <i class="el-icon-plus"></i> {{ $t('taskPage.left.addTask') }}
            </div>
            <div class="status-select">
                <el-col :span="9">
                    <el-select
                        v-model="select.taskStatus"
                        style="max-width: 8.4vw"
                        :placeholder="$t('taskPage.left.taskStatus')"
                        :popper-append-to-body="false"
                        clearable
                    >
                        <el-option
                            v-for="item in taskStatuslist"
                            :key="item.dictValue"
                            :label="item.dictLabel"
                            :value="item.dictValue"
                        >
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="8">
                    <div class="select">
                        <el-select
                            v-model="select.model"
                            @blur="taskTypeChange"
                            @clear="taskTypeClear"
                            style="max-width: 8.4vw"
                            :placeholder="$t('taskPage.left.executionMethod')"
                            clearable
                            collapse-tags
                            :popper-append-to-body="false"
                            popper-class="select"
                        >
                            <el-option
                                v-for="dict in modelData"
                                :key="dict.dictValue"
                                :label="dict.dictLabel"
                                :value="dict.dictValue"
                            />
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="7" class="date-select">
                    <el-date-picker
                        class="date-select-picker"
                        v-model="select.time"
                        type="date"
                        :placeholder="$t('taskPage.left.dateFilter')"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        popper-class="mydata"
                    >
                    </el-date-picker>
                    <i v-if="!select.time" class="el-icon-date date-right"></i>
                </el-col>
            </div>
            <div :class="{ 'left-tontent-tasklist': hasAdd, 'left-tontent-tasklist_1': !hasAdd }">
                <div class="task-info-list">
                    <!-- <YScroll>-->
                    <template v-if="taskPageList && taskPageList.length > 0">
                        <div
                            v-for="(item, index) in taskPageList"
                            @click="getMapLine(item)"
                            @mouseover.stop="SeeToolip(item, index)"
                            :key="item.id"
                        >
                            <el-tooltip
                                v-model="item.showDetail"
                                effect="dark"
                                placement="right-start"
                                popper-class="cell-tooltip"
                            >
                                <template v-slot:content>
                                    <taskTooltip
                                        v-if="item.showDetail"
                                        :tip="item"
                                        :modelData="modelData"
                                        :width="306"
                                        :modules="modules"
                                        :translate="(key) => $t(key)"
                                    ></taskTooltip>
                                </template>
                                <div
                                    :class="[
                                        item.taskStatus === '1' || item.taskStatus == '2'
                                            ? 'bg-green'
                                            : item.taskStatus === '3' ||
                                              item.taskStatus == '4' ||
                                              item.taskStatus == '5'
                                            ? 'bg-blue'
                                            : item.taskStatus === '6'
                                            ? 'bg-gray'
                                            : '',
                                        'task-content-oneLine',
                                    ]"
                                >
                                    <div class="task-info-status">
                                        <el-tag
                                            :class="{
                                                'is-unstart': item.taskStatus == 1,
                                                'is-starting': item.taskStatus == 2,
                                                'is-started': item.taskStatus == 3,
                                                'is-resulted': item.taskStatus == 4,
                                                'is-end': item.taskStatus == 5,
                                                'is-stop': item.taskStatus == 6,
                                            }"
                                            >{{
                                                item.taskStatus == 1
                                                    ? $t('taskPage.left.pendingExecution')
                                                    : '' || item.taskStatus == 2
                                                    ? $t('taskPage.left.executing')
                                                    : '' || item.taskStatus == 3 || item.taskStatus == 4
                                                    ? $t('taskPage.left.pendingUploadData')
                                                    : '' || item.taskStatus == 5
                                                    ? $t('taskPage.left.completed')
                                                    : '' || item.taskStatus == 6
                                                    ? $t('taskPage.left.terminated')
                                                    : ''
                                            }}</el-tag
                                        >
                                    </div>
                                    <div class="task-info-value">
                                        <div class="task-info-left">
                                            <CustomMarquee :duration="5" deb style="font-size: 14px">
                                                {{ item.name }}
                                            </CustomMarquee>
                                        </div>
                                        <div class="exe-type">
                                            {{ $t('taskPage.left.executionMethod') }} :
                                            {{ getModelName(item.model) }}
                                        </div>
                                        <div class="exe-type" style="font-size: 12px">
                                            {{
                                                item.taskStatus == 1
                                                    ? $t('taskPage.left.planExecutionTime')
                                                    : $t('taskPage.left.actualExecutionTime')
                                            }}
                                            :
                                            {{
                                                item.taskStatus == 1 ? item.planStartTime : item.executionTime
                                            }}
                                        </div>
                                        <div calss="task-info-right">
                                            <div
                                                class="task-info-box"
                                                v-if="item.taskStatus == 5"
                                                @click.stop="historyVideo(item)"
                                            >
                                                <el-tooltip
                                                    effect="dark"
                                                    :content="$t('taskPage.left.historyPlayback')"
                                                    placement="top"
                                                    popper-class="icon-tooltip"
                                                >
                                                    <div class="cell-img borderRight-white img-history"></div>
                                                </el-tooltip>
                                            </div>
                                            <div
                                                class="task-info-box"
                                                v-has="'fcs:control:cmd'"
                                                v-if="item.taskStatus == 3"
                                                @click.stop="taskOver(item)"
                                            >
                                                <el-tooltip
                                                    effect="dark"
                                                    :content="$t('taskPage.left.completeUpload')"
                                                    placement="top"
                                                    popper-class="icon-tooltip"
                                                >
                                                    <div
                                                        class="cell-img borderRight-white img-endUpload"
                                                    ></div>
                                                </el-tooltip>
                                            </div>
                                            <!-- <div
                                                class="task-info-box"
                                                v-has="'fcs:task:edit'"
                                                v-if="item.taskStatus == 3"
                                                @click.stop="uploadTaskData(item)"
                                            >
                                                <el-tooltip
                                                    effect="dark"
                                                    :content="$t('taskPage.left.uploadFlightData')"
                                                    placement="top"
                                                    popper-class="icon-tooltip"
                                                >
                                                    <div
                                                        class="cell-img borderRight-white img-uploadFly"
                                                    ></div>
                                                </el-tooltip>
                                            </div> -->
                                            <!-- <div
                                                    class="task-info-box"
                                                    v-has="'fcs:task:query'"
                                                    v-if="item.taskStatus == 4"
                                                    @click.stop="resultUpload(item)"
                                                >
                                                    <el-tooltip
                                                    effect="dark"
                                                    content="上传结果"
                                                    placement="top"
                                                    popper-class="icon-tooltip"
                                                    >
                                                    <div class="cell-img borderRight-white img-upload"></div>
                                                    </el-tooltip>
                                            </div>-->
                                            <div
                                                class="task-info-box"
                                                v-has="'fcs:control:cmd'"
                                                v-if="item.model == '1' && item.taskStatus == '1'"
                                                @click.stop="ConfirmTask(item)"
                                            >
                                                <el-tooltip
                                                    effect="dark"
                                                    :content="$t('taskPage.left.confirmTask')"
                                                    placement="top"
                                                    popper-class="icon-tooltip"
                                                >
                                                    <div class="cell-img borderRight-white img-confirm"></div>
                                                </el-tooltip>
                                            </div>
                                            <div
                                                class="task-info-box"
                                                v-has="'fcs:control:cmd'"
                                                v-if="
                                                    item.model != '1' &&
                                                    item.taskStatus != '5' &&
                                                    item.taskStatus != '6'
                                                "
                                                @click.stop="openFlightControlPage(item)"
                                            >
                                                <el-tooltip
                                                    popper-class="icon-tooltip"
                                                    effect="dark"
                                                    :content="$t('taskPage.left.startExecution')"
                                                    placement="top"
                                                >
                                                    <div class="cell-img borderRight-white img-control"></div>
                                                </el-tooltip>
                                            </div>
                                            <div
                                                class="task-info-box"
                                                v-if="item.taskStatus == 6"
                                                @click.stop="stopRea(item, true)"
                                            >
                                                <el-tooltip
                                                    effect="dark"
                                                    :content="$t('taskPage.left.terminateReason')"
                                                    placement="top"
                                                    popper-class="icon-tooltip"
                                                >
                                                    <div class="cell-img img-stop borderRight-white"></div>
                                                </el-tooltip>
                                            </div>
                                            <div
                                                class="task-info-box"
                                                v-has="'fcs:task:query'"
                                                @click.stop="detail(item)"
                                            >
                                                <el-tooltip
                                                    effect="dark"
                                                    popper-class="icon-tooltip"
                                                    :content="$t('taskPage.left.detail')"
                                                    placement="top"
                                                >
                                                    <div class="cell-img img-detail borderRight-white"></div>
                                                </el-tooltip>
                                            </div>
                                            <div
                                                @click.stop="editTask(item)"
                                                class="task-info-box"
                                                v-has="'fcs:task:edit'"
                                                v-if="item.taskStatus < 2"
                                            >
                                                <el-tooltip
                                                    effect="dark"
                                                    popper-class="icon-tooltip"
                                                    :content="$t('taskPage.left.edit')"
                                                    placement="top"
                                                >
                                                    <div class="cell-img img-editor borderRight-white"></div>
                                                </el-tooltip>
                                            </div>
                                            <div
                                                @click.stop="editTask(item)"
                                                class="task-info-box"
                                                v-has="'fcs:task:edit'"
                                                v-if="item.taskStatus > 2"
                                            >
                                                <el-tooltip
                                                    effect="dark"
                                                    popper-class="icon-tooltip"
                                                    :content="$t('taskPage.left.dataCorrection')"
                                                    placement="top"
                                                >
                                                    <div class="cell-img img-editor borderRight-white"></div>
                                                </el-tooltip>
                                            </div>
                                            <div
                                                @click.stop="taskEnd(item)"
                                                class="task-info-box"
                                                v-has="'fcs:control:cmd'"
                                                v-if="item.taskStatus == 2"
                                            >
                                                <el-tooltip
                                                    effect="dark"
                                                    :content="$t('taskPage.left.endExecution')"
                                                    placement="top"
                                                    popper-class="icon-tooltip"
                                                >
                                                    <div class="cell-img borderRight-white img-end"></div>
                                                </el-tooltip>
                                            </div>
                                            <div
                                                @click.stop="taskStop(item)"
                                                class="task-info-box"
                                                v-has="'fcs:control:cmd'"
                                                v-if="item.taskStatus == 2"
                                            >
                                                <el-tooltip
                                                    effect="dark"
                                                    :content="$t('taskPage.left.terminateTask')"
                                                    placement="top"
                                                    popper-class="icon-tooltip"
                                                >
                                                    <div class="cell-img borderRight-white img-terani"></div>
                                                </el-tooltip>
                                            </div>
                                            <div
                                                class="task-info-box"
                                                v-has="'fcs:task:edit'"
                                                v-if="item.taskStatus == '1'"
                                                @click.stop="copyTask(item.id)"
                                            >
                                                <el-tooltip
                                                    effect="dark"
                                                    :content="$t('taskPage.left.copy')"
                                                    placement="top"
                                                    popper-class="icon-tooltip"
                                                >
                                                    <div class="cell-img img-copy borderRight-white"></div>
                                                </el-tooltip>
                                            </div>
                                            <div
                                                class="task-info-box"
                                                v-has="'fcs:task:remove'"
                                                v-if="item.taskStatus != 2"
                                                @click.stop="clearTask(item.id)"
                                            >
                                                <el-tooltip
                                                    effect="dark"
                                                    :content="$t('taskPage.left.delete')"
                                                    placement="top"
                                                    popper-class="icon-tooltip"
                                                >
                                                    <div class="cell-img borderRight-white img-clear"></div>
                                                </el-tooltip>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </el-tooltip>
                        </div>
                        <div style="height: 50px"></div>
                    </template>
                    <template v-else>
                        <div class="nullData">
                            <div>
                                <img :src="require('@/page/mainPage/components/imgs/nodata.png')" alt="" />
                                <p>{{ $t('taskPage.left.nullData') }}</p>
                                <p>{{ $t('taskPage.left.nullSuggestionTips') }}</p>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <div
                :class="{ footer: hasAdd, footer_1: !hasAdd }"
                v-if="taskPageList && taskPageList.length > 0"
            >
                <el-pagination
                    class="table-footer-right"
                    small
                    background
                    layout="prev, pager, next"
                    :pager-count="5"
                    :current-page.sync="pageArray.currentPage"
                    :page-size.sync="pageArray.pageSize"
                    :total="pageArray.totalResult"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { YScroll } from '@CommonComponent';
import VXETable from 'vxe-table';
import moment from 'moment';
import api from '../api';
import CustomMarquee from '@/page/mainPage/components/CustomMarquee/CustomMarquee.vue';
import taskTooltip from './components/taskTooltip.vue';
import Airline from '@/page/routePage/main/Airline.vue';
import routeApi from '@/page/routePage/main/api.js';
import { addDateRange } from '@/utils/common.js';

export default {
    components: { CustomMarquee, taskTooltip },
    props: {
        refresh: {
            type: Boolean,
            default: false,
        },
        modelData: {
            type: Array,
            default: () => [],
        },
    },
    inject: ['modules'],
    data() {
        return {
            taskPageList: [],
            pageArray: {
                currentPage: 1,
                pageSize: 10,
                totalResult: 0,
            },
            resultShow: false,
            select: {
                taskStatus: '',
                model: '',
                time: moment().format('YYYY-MM-DD'),
            },
            userObj: this.$store.state.userInfo.userInfo.permissions,
            // loading: null,
            showAddtask: false,
            taskStatuslist: [],
            exeTypeLabel: [],
            isRG: 0,
            isJK: 0,
            taskexeType: [],
            exeProps: {
                children: 'children',
                label: 'label',
            },
            type: 1,
            hives: [],
            hasAdd: true,
            uavs: [],
            active: -1,
            airlineConfig: {},
        };
    },
    computed: {
        appCode() {
            // 取当前所属应用，优先从路由参数中取，如果没有再从localStorage中取
            let appCode = this.$route.query.appCode || localStorage.getItem('appCode') || '';
            // console.log('appCode',appCode)
            return appCode;
        },
    },
    watch: {
        refresh() {
            this.initTable();
        },
        select: {
            handler(newVal, oldVal) {
                if (newVal) {
                    // console.log(newVal, "222222222");
                    this.pageArray.currentPage = 1;
                    this.initTable();
                }
            },
            // immediate: true,
            deep: true, // 可以深度检测到 person 对象的属性值的变化
        },
    },
    mounted() {
        // console.log(this.$props.modelData, "ddd");
        this.getDate();
        // this.getAll();

        this.hasAdd = this.userObj['fcs:task:add'];
        let { search } = this.$store.state.Common.PageBackObj;
        // console.log(this.userObj, 999);
        if (Object.keys(search).length > 0) {
            this.pageArray = {
                currentPage: search.currentPage,
                pageSize: search.pageSize,
                totalResult: search.totalResult,
            };
            this.select = {
                taskStatus: search.taskStatus,
                time: search.time,
                model: search.model,
            };
        }
        this.initTable();
        // this.pageArray = Object.keys(search).length ? page : this.pageArray;
    },
    beforeDestroy() {
        // this.modules.MainModule.MixMapModule.input.map2dContent.delete(this.renderMapLayers);
    },
    methods: {
        getModelName(val) {
            const result = this.$props.modelData.filter((item) => item.dictValue === val)[0];
            return result.dictLabel;
        },
        // dateChange(val) {
        //   this.initTable();
        // },
        loadTreeBack(data) {
            if (data.model === '1') {
                this.isJK = 1;
                this.exeTypeLabel = [this.$t('i18n.929105-26')];
                this.exeTypeArr = [...data.exeTypeArr];
                this.loadTree(this.exeTypeArr);
            }
            if (data.model === '2') {
                this.isRG = 1;
                this.exeTypeLabel = [this.$t('i18n.929105-27')];
                this.exeTypeArr = [];
                this.loadTree(['2']);
            }
            if (data.model === '') {
                this.exeTypeLabel = [];
            }
        },
        // getAll() {
        //   api
        //     .getAllInfo()
        //     .run(false)
        //     .then((el) => {
        //       let { buss } = el;
        //       this.hives = buss.hives;
        //       this.uavs = buss.uavs;
        //       // console.log(this.$t('i18n.929105-26'), this.hives);
        //     });
        // },

        getMapLine(obj) {
            // console.log("getLine", obj);
            this.getAirline(obj.routeId);
        },
        getAirline(id) {
            this.airlineConfig = {};
            routeApi.getRouteInfo(id).then((res) => {
                let { coordinates } = res.data;
                let j = coordinates && JSON.parse(coordinates);
                this.airlineConfig = { ...j.airlineConfig };
                this.modules.MainModule.MixMapModule.input.map2dContent.delete(this.renderMapLayers);
                this.modules.MainModule.MixMapModule.input.map2dContent.push(this.renderMapLayers);
            });
        },

        addNewTask() {
            this.$emit('showAddAndEditor', '');
        },
        renderMapLayers() {
            // 这个是hover的任务信息
            let airlineConfig = this.airlineConfig;
            let type = '';
            let routeObj = {
                RouteValue: '',
                lineType: airlineConfig.type,
                searchHive: {},
                SeeShow: true,
                airT: 0,
                CurrentVal: {},
                rightShow: false,
                importState: false,
                altitudeLayers: [],
            };
            return <Airline type={type} routeObj={routeObj} airlineConfig={airlineConfig}></Airline>;
        },
        // 字符串截取 包含对中文处理,str需截取字符串,start开始截取位置,n截取长度
        Substring(str, start, n) {
            // eslint-disable-line
            if (str.replace(/[\u4e00-\u9fa5]/g, '**').length <= n) {
                return str;
            }
            let len = 0;
            let tmpStr = '';
            for (let i = start; i < str.length; i++) {
                // 遍历字符串
                if (/[\u4e00-\u9fa5]/.test(str[i])) {
                    // 中文 长度为两字节
                    len += 2;
                } else {
                    len += 1;
                }
                if (len > n) {
                    break;
                } else {
                    tmpStr += str[i];
                }
            }
            return tmpStr;
        },

        taskTypeChange() {
            this.pageArray.currentPage = 1;
        },
        taskTypeClear() {
            // this.exeTypeLabel = [];
            // this.exeTypeArr = [];
            this.select.model = '';
            // this.$nextTick(() => {
            //   this.$refs.exetree.setCheckedKeys([]);
            // });
        },

        clearTask(el) {
            // 删除任务
            api.deleteTask(el)
                .then((v) => {
                    if (v.code == 200) {
                        this.$message.success(this.$t('taskPage.left.deleteSuccess'));
                        this.initTable();
                    }
                })
                .catch((err) => {
                    this.$message(this.$t('taskPage.left.deleteFailed'));
                });
        },
        copyTask(el) {
            api.copyTask(el)
                .then((v) => {
                    if (v.code == 200) {
                        this.$message.success(this.$t('taskPage.left.copySuccess'));
                        this.initTable();
                    } else {
                        this.$message(this.$t('taskPage.left.copyFailed'));
                    }
                })
                .catch((err) => {});
        },
        async startTask(el) {
            let uavCode = null;
            let hiveCode = null;
            VXETable.modal.confirm(this.$t('taskPage.left.confirmExecution')).then((type) => {
                // return;
                if (el.model === '1') {
                    let hive = this.hives.find((hiveItem) => hiveItem.siteId === el.siteId);
                    if (hive) {
                        hiveCode = hive.code;
                    }
                }
                if (el.model === '2') {
                    let uav = this.uavs.find((uavItem) => uavItem.id === el.uavId);
                    if (uav) {
                        uavCode = uav.code;
                    }
                }
                // return;
                if (type === 'confirm') {
                    api.completeTask({
                        id: el.id,
                        taskStatus: '2',
                    })
                        .run()
                        .then((v) => {
                            this.select.taskStatus = '0';
                            // this.initTable();
                            this.$router.push({
                                path: 'console',
                                query: {
                                    type: 1,
                                    taskId: el.taskId,
                                    hiveCode,
                                    uavCode,
                                },
                            });
                            this.$store.commit('SET_PAGEOBJ', {
                                search: {
                                    ...this.pageArray,
                                    ...this.select,
                                    exeTypeArr: this.exeTypeArr,
                                },
                            });
                        });
                }
            });
        },
        async openFlightControlPage(el) {
            // 实时直播
            VXETable.modal.confirm(this.$t('taskPage.left.confirmFlightControl')).then((type) => {
                if (type === 'confirm') {
                    console.log('el', el);
                    this.$router.push({
                        path: 'console',
                        query: {
                            type,
                            taskId: el.id,
                            dockId: el.dockId,
                            uavCode: el.droneId,
                        },
                    });
                    this.$store.commit('SET_PAGEOBJ', {
                        search: { ...this.pageArray, ...this.select, exeTypeArr: this.exeTypeArr },
                    });
                }
            });
        },
        async detail(el) {
            // 任务详情
            this.$router.push({
                path: '/taskDetail',
                query: {
                    taskId: el.id,
                    page: 'first',
                    controls: 'detail',
                },
            });
            this.$store.commit('SET_PAGEOBJ', {
                search: { ...this.pageArray, ...this.select },
            });
        },
        stopRea(el) {
            this.$emit('showPageIndex', { stop: el });
        },
        editTask(el) {
            this.$router.push({
                path: '/taskDetail',
                query: {
                    taskId: el.id,
                    page: 'first',
                    controls: 'edit',
                },
            });
            this.$store.commit('SET_PAGEOBJ', {
                search: { ...this.pageArray, ...this.select },
            });
        },
        toResult(el) {
            // 查看结果
            this.$router.push({
                path: '/taskDetail',
                query: {
                    taskId: el.id,
                    routeId: el.routeId,
                    siteId: el.siteId,
                    status: el.taskStatus,
                    page: 'five',
                },
            });
            this.$store.commit('SET_PAGEOBJ', {
                search: { ...this.pageArray, ...this.select, exeTypeArr: this.exeTypeArr },
            });
        },
        async historyVideo(el) {
            // 历史回放
            this.$router.push({
                path: '/taskDetail',
                query: {
                    taskId: el.id,
                    page: 'third',
                },
            });
            this.$store.commit('SET_PAGEOBJ', {
                search: { ...this.pageArray, ...this.select, exeTypeArr: this.exeTypeArr },
            });
        },
        async taskOver(data) {
            this.$emit('taskHandle', { data, eve: 'taskOver' });
            // 完成处理
            // if (num === '4' && !el.sortiesCount) {
            //     this.$message.error('请先上传飞行数据');
            //     return;
            // }

            // VXETable.modal
            //   .confirm(num === "4" ? "确定完成上传吗？" : "确定完成处理吗？")
            //   .then((type) => {
            //     if (type === "confirm") {
            //       api
            //         .completeTask({
            //           id: el.id,
            //           taskStatus: num,
            //         })
            //         .run()
            //         .then((v) => {
            //           this.initTable();
            //         })
            //         .catch((err) => {
            //           this.$message(num === "4" ? "完成上传失败" : "完成处理失败");
            //         });
            //     }
            //   });
        },
        async resultUpload(el) {
            // 上传结果
            this.$router.push({
                path: '/taskDetail',
                query: {
                    taskId: el.id,
                    routeId: el.routeId,
                    siteId: el.siteId,
                    status: el.taskStatus,
                    type: el.applyName,
                    page: 'fourth',
                },
            });
            this.$store.commit('SET_PAGEOBJ', {
                search: { ...this.pageArray, ...this.select, exeTypeArr: this.exeTypeArr },
            });
        },
        async uploadTaskData(el) {
            if (el.planId) {
                // 上传飞行数据
                this.$store.commit('SET_UPLOADOBJ', {
                    uploadVisible: true,
                    planId: el.planId,
                    routeId: el.routeId || '',
                });
            } else {
                this.$message.error(this.$t('taskPage.uploadFlyData.noFlightRecord'));
            }
        },
        taskEnd(data) {
            this.$emit('taskHandle', { data, eve: 'taskEnd' });
        },
        taskStop(data) {
            this.$emit('taskHandle', { data, eve: 'taskStop' });
        },
        ConfirmTask(data) {
            this.$emit('taskHandle', { data, eve: 'confirmTask' });
        },
        async initTable() {
            let obj = {
                pageNum: this.pageArray.currentPage,
                pageSize: 10,
                taskStatus: this.select.taskStatus || undefined,
                model: this.select.model || undefined,
                appCode: this.appCode,
                // siteId: this.exeTypeArr.join(","),
            };
            const data = addDateRange(obj, this.select.time, 'plan');
            let res = await api.getPageList(data);
            this.taskPageList = res.rows || [];
            this.pageArray.totalResult = res.total || 0;
        },
        handleCurrentChange(val) {
            this.pageArray.currentPage = val;
            this.initTable();
        },
        handleSizeChange(val) {},
        SeeToolip(item, index) {
            this.active = index;
        },
        async getDate() {
            let res = await api.getSysDict('dict_task_status');
            if (res.data.length > 0) {
                this.taskStatuslist = res.data;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@Theme/config.scss';
@import '~@Theme/mixins/index.scss';
@import '../common/css/borderRight.css';
@import '@/global/common.scss';

.cairline-left {
    // overflow: hidden;
    height: 100%;
}
.select {
    &::v-deep .el-select-dropdown__item {
        padding: 0 10px;
        // margin: 0 10px;
    }
    &::v-deep .el-select-dropdown__item:hover {
        background-color: #071150 !important;
        opacity: 1;
        border: 0px;
    }
    &::v-deep .el-select-dropdown__list {
        padding-right: 12px;
    }
    &::v-deep .el-tag.el-tag--info .el-tag__close {
        display: none;
    }
    &::v-deep .el-checkbox__inner {
        border: 1px solid;
    }
    &::v-deep .el-icon-caret-right:before {
        display: none;
    }
    &::v-deep .el-checkbox__inner::after {
        // display: none;
        border: 1px solid #000;
        border-left: 0;
        border-top: 0;
    }
    &::v-deep .el-tree-node.is-expanded.is-checked > .el-tree-node__content > .el-tree-node__label {
        color: #49f0fd;
    }
    &::v-deep .el-tree-node.is-checked > .el-tree-node__label {
        // background-color: #ccc !important;
        color: #49f0fd;
    }
    &::v-deep .el-tree {
        background-color: #071150;
        color: #fff;
    }
    &::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #49f0fd;
        color: #49f0fd;
        border: 1px solid;
    }
    &::v-deep .el-checkbox > .el-checkbox__input.is-indeterminate > .el-checkbox__inner::before {
        background-color: #000;
    }
    &::v-deep .el-checkbox > .el-checkbox__input.is-indeterminate > .el-checkbox__inner {
        background-color: #49f0fd;
    }
}

@include b(left, cairline) {
    color: white;
    height: 94%;

    &::v-deep .el-tooltip__popper {
        border: 1px solid #49e7fd;
    }

    .showModel {
        z-index: 3002;
    }

    @include e(left) {
        width: 300px;
        height: 100%;
        position: absolute;
        top: 0px;
        left: 0px;
        background-color: #03053d;
        overflow: hidden;
    }

    .left-title {
        position: relative;
        top: 3px;
        left: 0px;
        font-size: 18px;
        height: 5vh;
        width: 100%;
        line-height: 5vh;
        color: white;
        text-align: center;
        background: url(./imgs/group_bg-3.png) center center no-repeat;
        z-index: 2;
    }

    .left-content {
        width: calc(100% - 16px - 16px);
        height: calc(100% - 40px);

        // border: 1px red solid;
        margin: 0 16px;
        .nullData {
            display: grid;
            place-items: center; /* 同时实现水平和垂直居中 */
            height: 60vh;
            color: rgba(255, 255, 255, 0.6);
            text-align: center;
            p{
                padding: 5px 0;
            }
        }
        .add-btn {
            position: relative;
            margin-top: 16px;
            width: 100%;
            height: 37px;
            line-height: 37px;
            color: #000;
            // border: 1px red solid;
            text-align: center;
            background: linear-gradient(181deg, #1dc9ff 0%, #49f0fd 100%);
            border-radius: 2px 2px 2px 2px;
            opacity: 1;
        }

        .status-select {
            height: 34px;
            font-size: 12px;
            margin-top: 14px;
            text-align: center;
            position: relative;

            // overflow: hidden;
            .date-select {
                position: relative;

                .date-right {
                    position: absolute;
                    top: 50%;
                    right: 5px;
                    transform: translateY(-50%);
                    // float: right;
                }

                .date-select-picker {
                    &::v-deep .el-input__inner {
                        text-align: center;
                        padding-left: 2px !important;
                    }
                }

                &::v-deep .el-input--suffix .el-input__inner {
                    padding-right: 0;

                    &::v-deep .el-input--prefix .el-input__inner {
                        padding-left: 0 !important;
                    }
                }

                &::v-deep .el-date-editor.el-input,
                .el-date-editor.el-input__inner {
                    width: 85px !important;
                }
            }

            // &::v-deep .el-input__suffix{
            //     right: -2px !important;
            // }
            &::v-deep .el-select-dropdown {
                background: rgba(7, 17, 80, 0.75);
                box-shadow: inset 0px 1px 12px 0px rgba(26, 71, 164, 0.65);
                opacity: 1;
                border: 1px solid #49f0fd;
            }

            &::v-deep .el-icon-circle-close {
                // display: none;
                position: absolute;
                right: -8px;
                z-index: 999;
                // top: 2px;
                // transform: translate(-20%);
            }

            &::v-deep .el-input--small .el-input__inner {
                border-radius: 2px 2px 2px 2px;
                opacity: 1;
                border: 1px solid #1a47a4;
            }

            &::v-deep .el-select {
                padding: 0 2px;
                // background-color: #58bc58;
            }

            &::v-deep .el-select-dropdown__item.hover,
            .el-select-dropdown__item {
                color: #fff;
                background: #071150;

                &:hover {
                    background: linear-gradient(
                        270deg,
                        rgba(73, 240, 253, 0) 0%,
                        rgba(73, 240, 253, 0.4) 32%,
                        rgba(73, 240, 253, 0.4) 66%,
                        rgba(73, 240, 253, 0) 100%
                    );
                    border-radius: 0px 0px 0px 0px;
                    opacity: 1;
                }
            }

            &::v-deep .el-select-dropdown__item.selected {
                color: #49f0fd !important;
            }

            &::v-deep .el-popper[x-placement^='bottom'] .popper__arrow {
                left: 50% !important;
                transform: translateX(-50%) !important;
            }

            &::v-deep .el-select-dropdown__item {
                text-align: center;
            }

            &::v-deep .el-popper[x-placement^='bottom'] .popper__arrow::after {
                top: 0;
                color: #49f0fd !important;
                border-bottom-color: #49f0fd;
            }

            &::v-deep .el-input--suffix .el-input__inner {
                padding-right: 10px !important;
                // padding-left: 2px !important;
            }

            // &::v-deep .el-select {
            //     background-color: #1a47a4;
            // }
            &::v-deep .el-input--small .el-input__inner {
                border: 1px solid #1a47a4;
                background-color: transparent;
                color: #fff;
            }

            &::v-deep .el-input__prefix {
                display: none;
            }
        }
        .left-tontent-tasklist_1 {
            position: relative;
            // bottom: 30px;
            height: calc(100% - 40px);
            // height: 60vh;
            // overflow: hidden;
            overflow-y: auto;
            // padding-bottom: 10px;
            // margin-bottom: 10px;
            scrollbar-width: none;
            /* Firefox */
            -ms-overflow-style: none;

            /* IE10+ */
            &::-webkit-scrollbar {
                width: 0;
                /*滚动条宽度*/
                height: 0;
                /*滚动条高度*/
                background-color: #035372;
                // display: none; /* ChromeSafari */
            }

            &::-webkit-scrollbar-thumb {
                box-shadow: 0px 1px 3px #00a0e9 inset;
                /*滚动条的内阴影*/
                border-radius: 10px;
                /*滚动条的圆角*/
                background-color: #00a0e9;
                /*滚动条的背景颜色*/
            }

            ::v-deep .el-scrollbar__wrap {
                margin-bottom: 0 !important;
            }

            .task-info-list {
                height: calc(100% - 35px);
                padding-bottom: 10px;
                // height: 500px;
                // overflow: hidden;
                // margin-bottom: 50px;
                &:hover {
                    &::-webkit-scrollbar-thumb {
                        background-color: rgba(255, 255, 255, 0.3);
                    }
                }

                overflow-y: auto;
                &::-webkit-scrollbar {
                    width: 5px;
                    height: 0;
                }

                &::-webkit-scrollbar-thumb {
                    border-radius: 10px;
                    background-color: transparent;
                }
            }

            .task-content-twoLine {
                position: relative;
                // height: 8vh;
                width: calc(100% - 6px);
                overflow: hidden;
                // display: flex;
                margin-top: 9px;
                border-radius: 2px;

                .task-info-status {
                    position: absolute;
                    top: 30px;
                    right: 16px;
                    float: right;
                    width: auto;
                    text-align: center;
                    padding: auto 12px;
                    font-size: 14px;
                    // display: flex;
                    // justify-content: center;

                    // .name {
                    //     position: absolute;
                    //     left: 50%;
                    //     // // top:50%;
                    //     transform: translate(-50%, 0);
                    //     // margin: 0 auto;
                    // }
                }
            }

            .task-content-oneLine {
                position: relative;
                height: 122px;
                width: calc(100% - 6px);
                overflow: hidden;
                // display: flex;
                margin-top: 9px;
                border-radius: 2px;

                .task-info-status {
                    position: absolute;
                    float: right;
                    right: 16px;
                    top: 8px;
                    width: auto;
                    text-align: center;
                    padding: auto 12px;
                    font-size: 14px;
                    z-index: 2;
                    // display: flex;
                    // justify-content: center;

                    // .name {
                    //     position: absolute;
                    //     left: 50%;
                    //     // // top:50%;
                    //     transform: translate(-50%, 0);
                    //     // margin: 0 auto;
                    // }
                }

                .task-info-value {
                    position: relative;
                    margin: 0 10px;

                    .task-info-left {
                        width: 178px;
                        padding: 12px 0 6px 0;
                        // padding: 12px 0;
                        // max-height: 5vh;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                    .exe-type {
                        height: 22px;
                        font-size: 14px;
                        font-family: Microsoft YaHei UI-Normal, Microsoft YaHei UI;
                        font-weight: 400;
                        color: rgba(255, 255, 255, 0.7);
                        line-height: 22px;
                        margin-bottom: 6px;
                    }

                    .task-info-right {
                        left: 17px;
                        width: 200px;
                        height: 34px;
                        line-height: 34px;
                        display: flex;
                    }
                }
            }

            .bg-green {
                border: 1px solid rgba(92, 221, 120, 1);
                border-left-width: 5px;
                background: linear-gradient(
                    260deg,
                    rgba(98, 236, 186, 0.6) 0%,
                    rgba(98, 236, 186, 0.25) 38%,
                    rgba(98, 236, 186, 0.25) 65%,
                    rgba(98, 236, 186, 0.6) 100%
                ) !important;
                border-radius: 2px 2px 2px 2px;
                opacity: 1;
                border-image: linear-gradient(
                        90deg,
                        rgba(92, 221, 120, 0.8),
                        rgba(98, 236, 186, 0.25),
                        rgba(98, 236, 186, 0.25),
                        rgba(92, 221, 120, 0.8)
                    )
                    1 1;

                &:hover {
                    background: rgba(98, 236, 186, 0.7) 100% !important;
                }
            }

            .bg-blue {
                border: 1px solid #1959f5;
                border-left-width: 5px;
                background: linear-gradient(
                    260deg,
                    rgba(25, 89, 245, 0.6) 0%,
                    rgba(25, 89, 245, 0.25) 38%,
                    rgba(25, 89, 245, 0.25) 65%,
                    rgba(25, 89, 245, 0.6) 100%
                );
                border-radius: 2px 2px 2px 2px;
                opacity: 1;

                &:hover {
                    background-color: #1959f5 !important;
                }
            }

            .bg-gray {
                border: 1px solid #51799e;
                border-left-width: 5px;
                background: linear-gradient(
                    260deg,
                    rgba(81, 121, 158, 0.6) 0%,
                    rgba(81, 121, 158, 0.25) 38%,
                    rgba(81, 121, 158, 0.25) 65%,
                    rgba(81, 121, 158, 0.6) 100%
                );
                border-radius: 2px 2px 2px 2px;
                opacity: 1;

                &:hover {
                    background-color: #51799e !important;
                }
            }
        }
        .left-tontent-tasklist {
            position: relative;
            // bottom: 30px;
            height: calc(100% - 102px);
            // height: 60vh;
            // overflow: hidden;
            overflow-y: auto;
            // padding-bottom: 10px;
            // margin-bottom: 10px;
            scrollbar-width: none;
            /* Firefox */
            -ms-overflow-style: none;

            /* IE10+ */
            &::-webkit-scrollbar {
                width: 0;
                /*滚动条宽度*/
                height: 0;
                /*滚动条高度*/
                background-color: #035372;
                // display: none; /* ChromeSafari */
            }

            &::-webkit-scrollbar-thumb {
                box-shadow: 0px 1px 3px #00a0e9 inset;
                /*滚动条的内阴影*/
                border-radius: 10px;
                /*滚动条的圆角*/
                background-color: #00a0e9;
                /*滚动条的背景颜色*/
            }

            ::v-deep .el-scrollbar__wrap {
                margin-bottom: 0 !important;
            }

            .task-content-twoLine {
                position: relative;
                // height: 8vh;
                width: calc(100% - 6px);
                overflow: hidden;
                // display: flex;
                margin-top: 9px;
                border-radius: 2px;

                .task-info-status {
                    position: absolute;
                    top: 30px;
                    right: 16px;
                    float: right;
                    width: auto;
                    text-align: center;
                    padding: auto 12px;
                    font-size: 14px;
                    // display: flex;
                    // justify-content: center;

                    // .name {
                    //     position: absolute;
                    //     left: 50%;
                    //     // // top:50%;
                    //     transform: translate(-50%, 0);
                    //     // margin: 0 auto;
                    // }
                }
            }

            .task-content-oneLine {
                position: relative;
                height: 122px;
                width: calc(100% - 6px);
                overflow: hidden;
                // display: flex;
                margin-top: 9px;
                border-radius: 2px;

                .task-info-status {
                    position: absolute;
                    float: right;
                    right: 16px;
                    top: 8px;
                    width: auto;
                    text-align: center;
                    padding: auto 12px;
                    font-size: 14px;
                    z-index: 2;
                    // display: flex;
                    // justify-content: center;

                    // .name {
                    //     position: absolute;
                    //     left: 50%;
                    //     // // top:50%;
                    //     transform: translate(-50%, 0);
                    //     // margin: 0 auto;
                    // }
                }
                .task-info-value {
                    position: relative;
                    margin: 0 10px;

                    .task-info-left {
                        width: 178px;
                        // padding: 12px 0;
                        padding: 12px 0 6px 0;
                        // max-height: 5vh;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                    .exe-type {
                        height: 22px;
                        font-size: 14px;
                        font-family: Microsoft YaHei UI-Normal, Microsoft YaHei UI;
                        font-weight: 400;
                        color: rgba(255, 255, 255, 0.7);
                        line-height: 22px;
                        margin-bottom: 6px;
                    }

                    .task-info-right {
                        left: 17px;
                        width: 200px;
                        height: 34px;
                        line-height: 34px;
                        display: flex;
                        // &:not(:last-child){
                        //     border-right: none;
                        // }
                        // &:first-child{
                        //     margin-left: 0 !important;
                        // }
                    }
                }
            }

            .bg-green {
                border: 1px solid rgba(92, 221, 120, 1);
                border-left-width: 5px;
                background: linear-gradient(
                    260deg,
                    rgba(98, 236, 186, 0.6) 0%,
                    rgba(98, 236, 186, 0.25) 38%,
                    rgba(98, 236, 186, 0.25) 65%,
                    rgba(98, 236, 186, 0.6) 100%
                ) !important;
                border-radius: 2px 2px 2px 2px;
                opacity: 1;
                border-image: linear-gradient(
                        90deg,
                        rgba(92, 221, 120, 0.8),
                        rgba(98, 236, 186, 0.25),
                        rgba(98, 236, 186, 0.25),
                        rgba(92, 221, 120, 0.8)
                    )
                    1 1;

                &:hover {
                    background: rgba(98, 236, 186, 0.7) 100% !important;
                }
            }

            .bg-blue {
                border: 1px solid #1959f5;
                border-left-width: 5px;
                background: linear-gradient(
                    260deg,
                    rgba(25, 89, 245, 0.6) 0%,
                    rgba(25, 89, 245, 0.25) 38%,
                    rgba(25, 89, 245, 0.25) 65%,
                    rgba(25, 89, 245, 0.6) 100%
                );
                border-radius: 2px 2px 2px 2px;
                opacity: 1;

                &:hover {
                    background-color: #1959f5 !important;
                }
            }

            .bg-gray {
                border: 1px solid #51799e;
                border-left-width: 5px;
                background: linear-gradient(
                    260deg,
                    rgba(81, 121, 158, 0.6) 0%,
                    rgba(81, 121, 158, 0.25) 38%,
                    rgba(81, 121, 158, 0.25) 65%,
                    rgba(81, 121, 158, 0.6) 100%
                );
                border-radius: 2px 2px 2px 2px;
                opacity: 1;

                &:hover {
                    background-color: #51799e !important;
                }
            }
        }
    }

    .task-info-box {
        display: inline-block;
        width: 25px;
        height: 18px;
        line-height: 18px;
        // border-right: 1px solid rgba(255, 255, 255, 0.3);
        margin: 0 5px;

        .cell-img {
            height: 20px;
            width: 20px;
            // margin: 0 auto;
            cursor: pointer;
        }

        .img-clear {
            background-image: url('../imgs/delete-bin-line.png');
        }

        .img-copy {
            background-image: url('../imgs/file-copy-line.gray.png');
        }

        .img-editor {
            background-image: url('../imgs/edit-box-line.gray.png');
        }

        .img-terani {
            background-image: url('../imgs/Mask group.png');
        }

        .img-end {
            background-image: url('./imgs/jieshu 1.png');
        }

        .img-detail {
            background-image: url('../imgs/file-list-2-line.gray.png');
        }

        .img-stop {
            background-image: url('./imgs/stopNColor.png');
        }

        .img-result {
            background-image: url('./imgs/resNcolor.png');
        }

        .img-control {
            background-image: url('./imgs/zhiboc.png');
        }

        .img-start {
            background-image: url('../imgs/eject-fill.gray.png');
        }
        .img-confirm {
            background-image: url('../imgs/confirm.png');
        }

        .img-upload {
            background-image: url('../imgs/folder-upload-line.gray.png');
        }
        .img-uploadFly {
            background-image: url('../imgs/uploaddata-white.png');
        }

        .img-over {
            background-image: url('../imgs/check-double-line.gray.png');
        }

        .img-endUpload {
            background-image: url('../map/imgs/endUploadNcolor.png');
        }

        .img-history {
            background-image: url('./imgs/回放.png');
        }
    }

    .task-info-edital {
        width: 204px;
        height: 260px;
        border: 1px solid;
        padding: 16px 0;
        color: white;
        background: rgba(7, 17, 80, 0.75);
        box-shadow: inset 0px 1px 12px 0px rgba(26, 71, 164, 0.65);
        opacity: 1;
        border: 1px solid #49f0fd;
    }
    .footer {
        // margin-top: 10px;
        // width: 320px;
        // overflow: hidden;
        display: flex;
        justify-content: center;
        position: relative;

        &::after {
            content: '';
            position: absolute;
            bottom: 100%;
            width: 292px;
            height: 50px;
            background: linear-gradient(180deg, rgba(7, 17, 80, 0) 10%, #071150 100%);
        }

        .table-footer-right {
            // margin-top: 10px;
            overflow: hidden;

            // width: 220px;
            // position: absolute;
            // bottom: 1.25vh;
            &::v-deep .btn-next {
                /*对下一页的按钮样式进行修改*/
                background-color: #112d7b;
                color: #fff;
            }

            &::v-deep .btn-prev {
                /*对上一页的按钮样式进行修改*/
                background-color: #112d7b;
                color: #fff;
            }

            &::v-deep .el-pager {
                max-width: 224px;
                overflow: hidden;
            }

            &::v-deep .el-pager li:not(.disabled).active {
                /*当前选中页数的样式进行修改*/
                background: rgba(73, 240, 253, 0.2);
                border-radius: 2px 2px 2px 2px;
                opacity: 1;
                border: 1px solid rgba(73, 240, 253, 0.4);
            }

            &::v-deep .el-pager li {
                margin: 0 5px;
                background-color: #112d7b;
                border-radius: 2px;
                color: #fff;
            }
        }

        &::v-deep .el-pagination {
            padding: 0 5px !important;
            box-sizing: border-box;
        }
    }

    v-deep .el-tooltip.content-right {
        border: 1px solid #49e7fd;
    }
}
</style>

// vxe提示样式修改
<style lang="scss">
.vxe-modal--wrapper {
    .vxe-modal--box {
        height: 178px;
        background: #071150 !important;
        box-shadow: inset 0px 0px 10px 0px #49f0fd !important;
        border-radius: 6px 6px 0px 0px !important;
        opacity: 1;
        border: 1px solid #49f0fd !important;

        .vxe-modal--header {
            color: #fff;
            background: transparent;
            border-bottom: 1px solid transparent;

            .el-message-box__close {
                color: #fff !important;
            }
        }

        .vxe-modal--body {
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;
            font-size: 16px;
            flex-grow: 0;

            .vxe-modal--content {
                flex-grow: 0;
            }
        }

        .el-message-box__headerbtn .el-message-box__close {
            color: #fff !important;
        }

        .vxe-modal--footer {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 10px;

            .vxe-button.type--button.theme--primary:not(.is--disabled) {
                background-color: #49f0fd;
                border-color: transparent;

                &:hover {
                    color: black;
                }
            }

            button {
                width: 88px;
                height: 30px;
                background: #49f0fd;
                border-radius: 2px;
                opacity: 1;
                margin: 0 8px;
                color: black;

                &:nth-of-type(1) {
                    background: #143e73;
                    border: 1px solid #49f0fd;
                    color: #49f0fd;
                }
            }
        }
    }
}

.el-scrollbar__bar.is-vertical {
    // background-color: rgba(255, 255, 255, 0.3);
}
</style>
